import { TRANSACTION_TYPES } from '@/utils/constants';

const impactsRoutes = [
    {
        path: '/risks',
        name: 'RisksPage',
        component: () => import('../views/risk/RiskEvaluationComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: 'risks',
            module: 'risksManagement',

        }
    },
    {
        path: '/risks/recognition',
        name: 'RisksRecognitionPage',
        component: () => import('../views/risk/RiskRecognitionComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', 'SUPERADMIN'],
            permission: 'riskRecognition',
            module: 'risksManagement',


        }
    },
    {
        path: '/risks/management',
        name: 'RisksManagementPage',
        component: () => import('../views/risk/RiskMapsComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['risks', 'riskMaps'],
            module: 'risksManagement',

        }
    },
    {
        path: '/risks/treatments',
        name: 'TreatmentPlanPage',
        component: () => import('../views/risk/treatments/TreatmentPlanComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['risks', 'treatmentPlan'],
            module: 'risksManagement',

        }
    },
    {
        path: '/risks/controls-following',
        name: 'ControlsFollowingPage',
        component: () => import('../views/risk/following/ControlsFollowingComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['risks', 'controlsFollowing'],
            module: 'risksManagement',
            planFeature: 'control_tracking',


        }
    }
];

export default impactsRoutes;